<template>
  <ul v-show="isShown" :class="style['quick-response']">
    <li
      v-for="(action, index) in actions"
      :key="index"
      v-theme-outline
      :class="checkActionState(index)"
      @click="clickAction(action)"
    >
      {{ action.text }}
    </li>
  </ul>
</template>

<script>
import ActionWidget from './ActionWidget.vue'
import style from './scss/_quick_reply.scss'
import { EventBus } from 'ChatWidget/EventBus'
import { useAppStore } from 'Store/app'

export default {
  extends: ActionWidget,

  setup() {
    const appStore = useAppStore()

    return { appStore }
  },

  computed: {
    style: () => style,
    isShown() {
      return this.appStore.latestMessageID === this.chat.id && this.active
    }
  },

  mounted() {
    EventBus.$emit('scroll-to-latest-message')
  }
}
</script>
